import { CiCircleInfo } from "react-icons/ci";

import "./style.css";

interface TooltipProps {
  message: string;
}

const Tooltip = (props: TooltipProps) => (
  <div data-track="tooltip" className="relative">
    <span className="tooltip-icon">
      <CiCircleInfo />
    </span>
    <p className="tooltip-info font-lato text-xs">{props.message}</p>
  </div>
);

export default Tooltip;
